import request from '@/utils/request'

export function fetchLast(query) {
    return request({
        url: '/admin/insureLevel/getLast',
        method: 'get',
        params: query
    })
}

export function save(data) {
    return request({
        url: '/admin/insureLevel/save',
        method: 'post',
        data
    })
}

export function batchUpdate(data) {
    return request({
        url: '/admin/insureLevel/batchUpdate',
        method: 'post',
        data
    })
}
